import React from "react";

const CLASSNAME_BASE = "pdp-error-message";
const CLASSNAME_SIZE = {
  small: "pdp-error-message--small"
};

const ErrorMessage = ({size, children}) => {
  const classNames = [CLASSNAME_BASE];
  const sizeClass = CLASSNAME_SIZE[size];

  if (sizeClass) classNames.push(sizeClass);

  return <div className={classNames.join(" ")}>{children}</div>;
};

export default ErrorMessage;
